import { render, staticRenderFns } from "./image-preview-fallback.vue?vue&type=template&id=39a65095&scoped=true&"
import script from "./image-preview-fallback.vue?vue&type=script&lang=js&"
export * from "./image-preview-fallback.vue?vue&type=script&lang=js&"
import style0 from "./image-preview-fallback.vue?vue&type=style&index=0&id=39a65095&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a65095",
  null
  
)

export default component.exports